'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["Link"];
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import unescapedText from 'I18n/utils/unescapedText';
import styled from 'styled-components';
import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { MICRO_TRANSITION_TIMING } from 'HubStyleTokens/times';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UILink from 'UIComponents/link/UILink';
import ProfileCard from 'ecosystem-marketplace-core/components/cards/ProfileCard';
import { getIsPrerenderUserAgent } from 'ecosystem-marketplace-core/utils/userAgent';
import { ProfileListing } from 'marketplace-ui-solutions-core/records/ProfileListing';
import { getCanonicalAppContext } from '../../selectors/app';
import { getFullLocationUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLink = styled(props => {
  const {
      Link
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Link, Object.assign({}, rest));
}).withConfig({
  displayName: "ResultCard__StyledLink",
  componentId: "sc-17qecu1-0"
})(["display:flex;align-items:stretch;height:100%;width:", ";"], props => `${props.width}px` || '');
const StyledProfileCard = styled(ProfileCard).withConfig({
  displayName: "ResultCard__StyledProfileCard",
  componentId: "sc-17qecu1-1"
})(["&&{border:2px solid transparent;transition:border ", " ease-out;&:hover{border-color:", ";}}"], MICRO_TRANSITION_TIMING, CALYPSO_MEDIUM);
const ResultCard = ({
  onClick,
  result,
  width
}) => {
  const canonicalAppContext = useSelector(getCanonicalAppContext);
  const isPrerender = getIsPrerenderUserAgent();
  const history = useHistory();
  const {
    description,
    logoUrl,
    name,
    partnerType,
    reviewSummary,
    slug,
    tier
  } = result;
  const linkProps = useMemo(() => {
    const pathname = `/${slug}`;
    if (isPrerender) {
      return {
        Link: UILink,
        href: getFullLocationUrl({
          pathname
        }, canonicalAppContext)
      };
    }
    return {
      Link: UIRouterLink,
      to: {
        pathname,
        state: {
          // used in the ProfileHeader breadcrumb
          fromHomepage: history.location && history.location.pathname === '/'
        }
      }
    };
  }, [canonicalAppContext, history.location, isPrerender, slug]);
  return /*#__PURE__*/_jsx(StyledLink, Object.assign({}, linkProps, {
    width: width,
    "aria-label": unescapedText('ecosystem-marketplace-solutions-ui.storefront.results.resultsCard.accessibleLabel', {
      name
    }),
    onClick: onClick,
    use: "unstyled",
    children: /*#__PURE__*/_jsx(StyledProfileCard, {
      className: "m-bottom-0",
      description: description,
      logoUrl: logoUrl,
      name: name,
      partnerType: partnerType,
      reviewSummary: reviewSummary,
      tier: tier
    })
  }));
};
ResultCard.propTypes = {
  onClick: PropTypes.func,
  result: PropTypes.instanceOf(ProfileListing).isRequired,
  width: PropTypes.number
};
export default ResultCard;